import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-jc-center kn-height-full" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { for: "defaultRole" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Message = _resolveComponent("Message")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, null, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.roles')), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          (_ctx.selectedRoles.length > 1)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.defaultRole,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.defaultRole = $event)),
                      showClear: "true",
                      options: _ctx.selectedRolesWithEmpty(),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectDefaultRole($event))),
                      optionLabel: "name",
                      class: "p-inputtext p-component kn-material-input"
                    }, {
                      value: _withCtx((slotProps) => [
                        _createVNode("span", null, _toDisplayString(slotProps.value?.name), 1)
                      ]),
                      option: _withCtx((slotProps) => [
                        _createVNode("span", null, _toDisplayString(slotProps.option.name), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.usersManagement.form.defaultRole')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("p", null, [
            (_ctx.selectedRoles.length > 1)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  severity: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.defaultRoleInfo')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_DataTable, {
            value: _ctx.rolesList,
            onRowSelectAll: _ctx.onRowSelect,
            onRowUnselectAll: _ctx.onRowUnselect,
            selection: _ctx.selectedRoles,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedRoles = $event)),
            class: "p-datatable-sm kn-table",
            dataKey: "id",
            paginator: true,
            rows: 20,
            responsiveLayout: "stack",
            breakpoint: "960px",
            onRowSelect: _ctx.onRowSelect,
            onRowUnselect: _ctx.onRowUnselect
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                dataKey: "id",
                style: {"width":"50px"}
              }),
              _createVNode(_component_Column, {
                field: "name",
                header: _ctx.$t('common.name')
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "onRowSelectAll", "onRowUnselectAll", "selection", "onRowSelect", "onRowUnselect"])
        ]),
        _: 1
      })
    ])
  ]))
}